var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsSearch2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.03 23.76C7.11005 23.76 2.30005 18.95 2.30005 13.03C2.30005 7.11005 7.11005 2.30005 13.03 2.30005C18.95 2.30005 23.76 7.11005 23.76 13.03C23.76 18.94 18.94 23.76 13.03 23.76ZM13.03 3.35005C7.69005 3.35005 3.35005 7.69005 3.35005 13.03C3.35005 18.37 7.69005 22.71 13.03 22.71C18.37 22.71 22.71 18.37 22.71 13.03C22.7 7.69005 18.36 3.35005 13.03 3.35005Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.64 29.7099C27.09 29.7099 26.57 29.4999 26.18 29.0999L18.89 21.8099C18.79 21.7099 18.74 21.5799 18.74 21.4399C18.74 21.2999 18.8 21.1699 18.89 21.0699L21.06 18.8999C21.27 18.6899 21.6 18.6899 21.81 18.8999L29.1 26.1899C29.49 26.5799 29.7 27.0999 29.7 27.6499C29.7 28.1999 29.49 28.7199 29.1 29.1099C28.71 29.4899 28.19 29.7099 27.64 29.7099ZM20.01 21.4299L26.93 28.3499C27.31 28.7299 27.97 28.7299 28.36 28.3499C28.55 28.1599 28.66 27.9099 28.66 27.6399C28.66 27.3699 28.56 27.1199 28.36 26.9299L21.44 20.0099L20.01 21.4299Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48996 13.55C6.19996 13.55 5.95996 13.31 5.95996 13.02C5.95996 9.11995 9.12996 5.94995 13.03 5.94995C13.32 5.94995 13.56 6.18995 13.56 6.47995C13.56 6.76995 13.32 7.00995 13.03 7.00995C9.71996 7.00995 7.01996 9.70995 7.01996 13.02C7.01996 13.32 6.77996 13.55 6.48996 13.55Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsSearch2023);
export default __webpack_public_path__ + "static/media/beemg-icons-search-2023.6ef37a55a918adc2d1bb7222bda656d8.svg";
export { ForwardRef as ReactComponent };